import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ActiveLastBreadcrumb from './ActiveLastBreadcrumb';
import ClientProvider from './client';
export default createDemo(import.meta.url, ActiveLastBreadcrumb, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/breadcrumbs/demos/active-last/ActiveLastBreadcrumb.tsx",
    "fileName": "ActiveLastBreadcrumb.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Breadcrumbs from '@mui/material/Breadcrumbs';\nimport Link from '@mui/material/Link';\n\nfunction handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {\n  event.preventDefault();\n  console.info('You clicked a breadcrumb.');\n}\n\nexport default function ActiveLastBreadcrumb() {\n  return (\n    <div role=\"presentation\" onClick={handleClick}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Breadcrumbs aria-label=\"breadcrumb\">\n        <Link underline=\"hover\" color=\"inherit\" href=\"/\">\n          MUI\n        </Link>\n        <Link\n          underline=\"hover\"\n          color=\"inherit\"\n          href=\"/material-ui/getting-started/installation/\"\n        >\n          Core\n        </Link>\n        <Link\n          underline=\"hover\"\n          href=\"/material-ui/react-breadcrumbs/\"\n          aria-current=\"page\"\n          sx={{\n            color: 'text.primary',\n          }}\n        >\n          Breadcrumbs\n        </Link>\n      </Breadcrumbs>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 37,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Breadcrumbs from '@mui/material/Breadcrumbs';\nimport Link from '@mui/material/Link';\n\nfunction handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {\n  event.preventDefault();\n  console.info('You clicked a breadcrumb.');\n}\n\nexport default function ActiveLastBreadcrumb() {\n  return (\n    <div role=\"presentation\" onClick={handleClick}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <Breadcrumbs aria-label=\"breadcrumb\">\n        <Link underline=\"hover\" color=\"inherit\" href=\"/\">\n          MUI\n        </Link>\n        <Link\n          underline=\"hover\"\n          color=\"inherit\"\n          href=\"/material-ui/getting-started/installation/\"\n        >\n          Core\n        </Link>\n        <Link\n          underline=\"hover\"\n          href=\"/material-ui/react-breadcrumbs/\"\n          aria-current=\"page\"\n          sx={{\n            color: 'text.primary',\n          }}\n        >\n          Breadcrumbs\n        </Link>\n      </Breadcrumbs>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "totalLines": 37,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Breadcrumbs",
      "@mui/material/Link"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
